import { defaultAuthState } from './module-auth-state';
import commonFunc from '@/common/commonFunction';

export default {
	resetState(state) {
		Object.assign(state, defaultAuthState);
	},
	/**
	 * Cập nhật các thông tin liên quan tới accesstoken của mtax
	 */
	updateAccessToken: function(state, payload) {
		state.tokenType = payload.TokenType;
		state.mtaxAccessToken = payload.AccessToken;
		state.mTaxExpire = payload.ExpiresIn;
		state.expiredDate = commonFunc.parseStringToDate(payload.ExpiredDate);
		state.userInfo = payload.User;
		state.isRequiredLicense = payload.IsRequiredLicense;
		state.LinkSignalR = payload.LinkSignalR;
		state.RunSignalR = payload.RunSignalR;
		//Cờ chọn kênh (nguồn: MWSSettings.IsMWSEnabled) — ON: chỉ MWS; OFF: chỉ SignalR (loại trừ tuyệt đối)
		state.IsMWSEnabled = payload.IsMWSEnabled;
	},
	/**
	 * Cập nhật các thông tin liên quan tới accesstoken của misaid
	 */
	updateMisaToken: function(state, payload) {
		state.misaAccessToken = payload.AccessToken;
		state.misaExpire = payload.misaExpire;
		state.misaRefreshToken = payload.RefreshToken;
		state.EmailActive = payload.EmailActive;
		state.PhoneActive = payload.PhoneActive;
	},
	updateMisaRefreshToken: function(state, payload) {
		//Nếu có hành đồng RefreshToken thì cập nhật lại
		if (payload.IsRefreshToken) {
			state.misaAccessToken = payload.AccessToken;
			state.misaExpire = payload.ExpiresIn;
			state.misaRefreshToken = payload.RefreshToken;
		}
	},
	updateStatusActive: function(state, payload) {
		state.EmailActive = payload.EmailActive;
		state.PhoneActive = payload.PhoneActive;
	},
	updateIsLaterState: function(state, value) {
		state.isLater = value;
	},
	updateTimeout: function(state, value) {
		state.timeOut = value;
	},
	updateIsShowWarningLisence: function(state, value) {
		state.isShowWarningLisence = true;
	},
	updateSessionExchanged: function(state, value) {
		state.sessionExchanged = value;
	},
	// Cập nhật thông tin login của amis
	updateAmisAuthData: function(state, payload) {
		state.amisAuthData = payload;
	}
};
